// extracted by mini-css-extract-plugin
export default {"title":"TitleComp_title__y27fl"};